import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import MarketingHeader from '../layout/MarketingHeader'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import CookieModal from '../marketing/CookieModal';

@observer
class OnboardingLayout extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    const Content = this.props.content
    const SideContent = this.props.sideContent
    const TopContent = this.props.topContent

    const props = this.props;

    return (
      <div>
        <MarketingHeader/>
        <Wrapper>
          <ContentWrapper>
            { this.props.topContent && <TopContent /> }
            <ContentWrapperContent>
              <Content { ...props } />
            </ContentWrapperContent>
          </ContentWrapper>
          <SideContentWrapper>
            <SideContent { ...props } />
          </SideContentWrapper>
        </Wrapper>

        { /* MODALS */ }
        <CookieModal />
      </div>
    )
  }
}

const Wrapper = styled.div `
  display: grid;
  grid-template-columns: calc(50% + 100px) calc(50% - 100px);
  width: 100vw;
  height: calc( 100vh - ${ cssVar.headerHeight }px);
  margin-top: ${ cssVar.headerHeight }px;
  overflow: hidden;
  background: white;
  color: black;

  p {
    color: black;
  }

  ${cssVar.breakpoints.tablet} {
      display: block;
  }
`
const ContentWrapper = styled.div `
  max-width: ${cssVar.max_content_width / 2 + 50}px;
  margin: 0 0 0 auto;
  display: flex;
  align-items: flex-start;
  padding: 50px 50px 50px 50px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;

  ${cssVar.breakpoints.tablet} {
    margin: 0 auto;
    max-width: ${ cssVar.max_content_width }px;
  }

  ${cssVar.breakpoints.phone} {
    padding: 30px;
  }
`
const ContentWrapperContent = styled.div `
  width: 100%;
  height: auto;
  /*min-height: 100%;*/
  display: flex;
  align-items: center;
  flex: 1;
  > * {
    margin: auto;
  }
`

const SideContentWrapper = styled.div `
  background: #212D3D;
  width: 100%;
  height: 100%;
`

export default OnboardingLayout



// WEBPACK FOOTER //
// /src/components/onboarding/OnboardingLayout.js